import { t } from '@/i18n';
import type { analysisAxisEnum } from '@/utils/enum';
import groupBy from 'lodash-es/groupBy';
import type z from 'zod';
import type { ProjectAnalysisModels } from '../_models/project';

type Args = {
  data: z.infer<typeof ProjectAnalysisModels>;
  analysisAxis: z.infer<typeof analysisAxisEnum>;
};

export const getTableDataSource = ({
  data,
  analysisAxis,
}: Args): {
  id: string;
  organizationName: string;
  fiscalYears: {
    year: number;
    total: number | null;
  }[];
}[] => {
  return Object.entries(
    // 年度の場合は1行に収めたいので特定のkeyでグルーピング
    groupBy(data, analysisAxis === 'year' ? '' : 'analysisAxis.id'),
  ).map(([id, items]) => {
    return {
      id,
      organizationName:
        analysisAxis === 'year'
          ? t('total-amount')
          : (items[0]?.analysisAxis.name?.toString() ?? t('not-set')),
      fiscalYears: items.map((item) => ({
        year: item.fiscalYear,
        total: item.total,
      })),
    };
  });
};
